import React from 'react';
import ErrorIcon from '@atlaskit/icon/core/migration/error';
import { token } from '@atlaskit/tokens';
import { AkFlag as Flag } from '@atlassian/jira-flags'; // ignore-for-ENGHEALTH-17759
import { useIntl } from '@atlassian/jira-intl';
import { reload } from '@atlassian/jira-portfolio-3-portfolio/src/common/window/index.tsx';
import messages from './messages.tsx';

export const ReleaseFeatureDisabledSchedulingFailureErrorFlag = () => {
	const { formatMessage } = useIntl();
	return (
		<Flag
			key="release-feature-disabled-scheduling-failure"
			id="release-feature-disabled-scheduling-failure"
			icon={
				<ErrorIcon
					spacing="spacious"
					label={formatMessage(messages.errorFlagIconLabel)}
					color={token('color.icon.danger')}
				/>
			}
			title={formatMessage(messages.errorFlagTitle)}
			description={formatMessage(messages.errorFlagDescription)}
			actions={[
				{
					content: formatMessage(messages.reloadPlan),
					onClick: reload,
				},
			]}
		/>
	);
};
